import TicketDropdown from './TicketDropdown';
import { useTicketPropertyDefinitions } from 'conversations-inbox-lib/tickets/hooks/useTicketPropertyDefinitions';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import ReassignmentSelectDropdownContainer from '../../reassignment/ReassignmentSelectDropdownContainer';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { Collapser } from 'foundations-components/transitional/components/Collapser';
import { View } from 'foundations-components/components/View';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TICKET_OWNER_ID = 'hubspot_owner_id';
const TicketToolbarContent = ({
  ticket,
  threadId,
  inboxId
}) => {
  const definitionsResults = useTicketPropertyDefinitions();
  if (definitionsResults.loading) {
    return /*#__PURE__*/_jsx(TFlex, {
      flexDirection: "row",
      color: "text-core-subtle",
      role: "toolbar",
      "aria-busy": true,
      children: /*#__PURE__*/_jsx(SkeletonText, {})
    });
  }
  const fetchTicketPropertyDropdowns = () => {
    const ticketPropertyDropdowns = [];
    definitionsResults.propertyDefinitions.forEach(property => {
      if (property.hidden) {
        return;
      }

      // we don't want to render ticketOwner dropdown in Inbox
      if (property.name !== TICKET_OWNER_ID) {
        ticketPropertyDropdowns.push( /*#__PURE__*/_jsx(View, {
          minInlineSize: ticketPropertyDropdowns.length === 0 ? '118px' : '',
          minBlockSize: ticketPropertyDropdowns.length === 0 ? '62px' : '',
          children: /*#__PURE__*/_jsx(TicketDropdown, {
            label: /*#__PURE__*/_jsx(Text, {
              typography: "heading-50",
              children: property.label
            }),
            property: property,
            ticketId: ticket.id,
            disabled: !ticket.userPermissions.currentUserCanEdit,
            value: ticket.defaultProperties[property.name].value,
            ticket: ticket
          })
        }, property.name));
      }
      return;
    });
    return ticketPropertyDropdowns;
  };
  return /*#__PURE__*/_jsx(Collapser, {
    fallback: /*#__PURE__*/_jsxs(Flex, {
      role: "toolbar",
      "aria-busy": false,
      flexDirection: "row",
      children: [/*#__PURE__*/_jsx(Flex, {
        flexShrink: 0,
        children: /*#__PURE__*/_jsx(ReassignmentSelectDropdownContainer, {
          threadId: threadId,
          inboxId: inboxId
        })
      }), fetchTicketPropertyDropdowns()[0]]
    }),
    children: /*#__PURE__*/_jsxs(Flex, {
      role: "toolbar",
      "aria-busy": false,
      flexDirection: "row",
      children: [/*#__PURE__*/_jsx(Flex, {
        flexShrink: 0,
        marginBlockStart: "250",
        children: /*#__PURE__*/_jsx(ReassignmentSelectDropdownContainer, {
          threadId: threadId,
          inboxId: inboxId
        })
      }), fetchTicketPropertyDropdowns()]
    })
  });
};
TicketToolbarContent.displayName = 'TicketToolbarContent';
export default TicketToolbarContent;